import { useEffect, useState } from "react";

export default function useVisitorInfo() {
  const [info, setInfo] = useState({
    location: null, // { city, region, country, postal, ip }
    browser: null,
    device: null,
  });

  useEffect(() => {
    // Get max location detail from IP
    const getLocationFromIP = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        setInfo((prev) => ({
          ...prev,
          location: {
            ip: data.ip,
            city: data.city,
            region: data.region,
            country: data.country_name,
            postal: data.postal,
          },
        }));
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    // Get Browser
    const getBrowser = () => {
      const ua = navigator.userAgent;
      if (ua.includes("Chrome") && !ua.includes("Edge")) return "Chrome";
      if (ua.includes("Firefox")) return "Firefox";
      if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
      if (ua.includes("Edge")) return "Edge";
      if (ua.includes("OPR") || ua.includes("Opera")) return "Opera";
      return "Unknown";
    };

    // Get Device
    const getDeviceType = () => {
      const ua = navigator.userAgent;
      if (/Mobi|Android/i.test(ua)) return "Mobile";
      if (/Tablet|iPad/i.test(ua)) return "Tablet";
      return "Desktop";
    };

    // Set Browser & Device
    setInfo((prev) => ({
      ...prev,
      browser: getBrowser(),
      device: getDeviceType(),
    }));

    // Fetch location
    getLocationFromIP();
  }, []);

  return info;
}